import { apiConstructor as api } from '@/api/apiConstructor';
import { Page, PageEditorState, PageState } from '@/types/page';
import { AxiosResponse } from 'axios';

export async function getPages(): Promise<PageState> {
  try {
    const response: AxiosResponse = await api.get('pages');
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function getPage(id: string): Promise<Page> {
  try {
    const response: AxiosResponse = await api.get(`pages/${id}`);
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function savePage(page: PageEditorState): Promise<Page> {
  const url: string = page.id === null ? 'pages' : `pages/${page.id}`;

  const response: AxiosResponse =
    page.id === null
      ? await api.post(url, { ...page })
      : await api.put(url, { ...page });
  return response.data;
}
